export default __webpack_public_path__ + "static/media/category7.beff88fe.png";